export const openmodal = { // eslint-disable-line
  name: 'openmodal',
  bind: (el, binding, vnode) => {
    if (!binding.value) return

    if (isPdf(binding) && isMobile()) {
      // el.setAttribute('download', '')
      el.setAttribute('target', '_blank')
    }
    el.addEventListener('click', (event) => {
      if (isPdf(binding) && isMobile()) return

      event.preventDefault()
      vnode.context.$root.$emit('openmodal', binding.value)
    })
  }
}

const isMobile = () => {
  return window.innerWidth <= 1240
}

const isPdf = (binding) => {
  return binding.value.type === 'pdf'
}

// export const openmodal = { // eslint-disable-line
//   name: 'modal',
//   bind: (el, binding) => { // eslint-disable-line
//     const element = el

//     element.addEventListener('click', function(event) { // eslint-disable-line
//       event.preventDefault()

//       debugger

//       this.$root.$emit('openmodal')
//     })
//   }
// }
